// ...existing code...
import React, { useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Add, Description } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from '@tanstack/react-router';
import { actions } from './Reports.redux';
import ModalTemplateAddNew from './ModalTemplateAddNew';
import TemplatesCell from 'pages/Reports/TemplatesCell';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const TemplatesList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector((state) => state.reports.loading);
    const { rows, totalRows, lastQuery, pageSize, pageNumber } = useSelector((state) => state.reports.templates);

    const columns = [
        { field: 'template_name', headerName: 'Layout Name', flex: 1, minWidth: 220, sortable: false },
        { field: 'date_created', headerName: 'Date Created', flex: 1, minWidth: 180, sortable: false },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <TemplatesCell {...params} />,
        },
    ];

    const handlePaginationModelChange = (newModel) => {
        if (loading) {
            return;
        }

        dispatch(actions.setSubState('templates', { pageNumber: newModel.page, pageSize: newModel.pageSize }));
        dispatch(actions.loadTemplates());
    };

    useEffect(() => {
        if (lastQuery === '' && loading === false) {
            dispatch(actions.loadTemplates());
        }
    }, [lastQuery, loading, dispatch]);

    return (
        <DashboardCard
            color={'amber'}
            icon={<Description />}
            topContent={'Layouts'}
            topLabel={
                <div>
                    Select template to edit, or &nbsp;
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => dispatch(actions.setState({ showNewTemplateModal: true }))}
                    >
                        Add New
                    </Button>
                </div>
            }
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.template_id}
                    rowCount={Number(totalRows) || 0}
                    pagination
                    paginationMode="server"
                    pageSizeOptions={[5, 10, 20, 30]}
                    paginationModel={{ page: pageNumber, pageSize }}
                    onPaginationModelChange={handlePaginationModelChange}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    onRowClick={(params) => {
                        if (params.field !== 'actions') {
                            navigate({ to: `/reports/edit-layout/${params.row.template_id}` });
                        }
                    }}
                    autoHeight
                />
            </div>

            <ModalTemplateAddNew />
        </DashboardCard>
    );
};

export default TemplatesList;
